/* unplugin-vue-components disabled */import { render } from "./contact-suggestion.vue?vue&type=template&id=049f2efa&scoped=true"
import script from "./contact-suggestion.vue?vue&type=script&lang=js"
export * from "./contact-suggestion.vue?vue&type=script&lang=js"

import "./contact-suggestion.vue?vue&type=style&index=0&id=049f2efa&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049f2efa"],['__file',"src/components/search-dropdown/contact-suggestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "049f2efa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('049f2efa', __exports__)) {
    api.reload('049f2efa', __exports__)
  }
  
  module.hot.accept("./contact-suggestion.vue?vue&type=template&id=049f2efa&scoped=true", () => {
    api.rerender('049f2efa', render)
  })

}


export default __exports__